module.exports = __webpack_public_path__ + "img/marker_comer.e0fa7b12.svg";